<!--
 * @Author: CJX
 * @Date: 2020-03-26 14:36:50
 * @LastEditors: LZL
 * @LastEditTime: 2021-05-06 12:16:38
 * @Description: 菜单权限维护
 -->

<template>
  <hm-page-card
    v-loading="loading"
    class="c-card--detail page-permission-list"
    title="权限"
  >
    <template
      v-if="!loading && appPermissionList.length>0"
      v-slot:extra
    >
      <el-button
        icon="kestrel-icon ki-repeat"
        @click="handleReset(checkList)"
      >
        重 置
      </el-button>
      <el-button
        :loading="loading"
        type="primary"
        icon="kestrel-icon ki-save"
        @click="handleSave"
      >
        保 存
      </el-button>
    </template>
    <div
      v-if="!loading && appPermissionList.length===0"
      class="js-no-data"
    >
      无权限数据！
    </div>
    <el-collapse
      v-else
      v-model="activeNames"
    >
      <el-collapse-item
        v-for="appItem in appPermissionList"
        :key="appItem.appUuid"
        :title="appItem.appCode"
        :name="appItem.appCode"
      >
        <template v-slot:title>
          {{ appItem.appCode }}
        </template>
        <div
          v-for="(listItem,index) in appItem.permissionList"
          :key="index"
          class="dev-pGroup"
        >
          <div
            class="dev-pGroup__title"
          >
            <el-checkbox
              v-model="listItem.checkAll"
              :indeterminate="listItem.isIndeterminate"
              @change="handleCheckAllChange(index, listItem, appItem.appUuid)"
            >
              {{ listItem.groupName }}
            </el-checkbox>
          </div>
          <el-checkbox-group
            v-model="checkAlias['groupP_'+ appItem.appUuid + '_' +index]"
            class="dev-pGroup__detail"
            @change="handleCheckedChange(index, listItem, appItem.appUuid)"
          >
            <template
              v-for="_perItem in listItem.permissions"
            >
              <el-checkbox
                :key="_perItem.code"
                class="dev-pDetail"
                :label="_perItem.code"
              >
                <div
                  class="dev-pDetail__name"
                >
                  {{ _perItem.name }}
                </div>
                <div
                  class="dev-pDetail__code"
                >
                  {{ _perItem.code }}
                </div>
                <div
                  class="dev-pDetail__path"
                >
                  {{ _perItem.paths }}
                </div>
              </el-checkbox>
            </template>
          </el-checkbox-group>
        </div>
      </el-collapse-item>
    </el-collapse>
  </hm-page-card>
</template>

<script>
import { getPermissionTree, updateMenuPermission, getMenuPermission } from './permission.service.js';
export default {
  name: 'PermissionList',
  props: {
    // 菜单编码
    menuCode: {
      type: String,
      default: null
    },
    // 菜单元素编码
    elementCode: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      appPermissionList: [],
      loading: false, // 页面loading状态
      aliasPermissionList: [], // 权限列表，保存了分组信息，一维数组
      checkList: [], // 菜单勾选的权限
      checkAlias: {}, // 分组保存菜单勾选的权限

      /* 菜单权限关联参数 Start */
      fd: {
        menuCode: '',
        menuName: '',
        elementCode: '',
        sysPermissionVOList: []
      },
      /* 菜单权限关联参数 End */

      activeNames: [] // 折叠窗口展开参数
    };
  },
  methods: {
    /**
     * @description: 获取权限树
     * @param
     * @return {*}
     */
    getPermission () {
      getPermissionTree().then(rsp => {
        for (let i = 0; i < rsp.data.length; i++) {
          const ap = {};
          ap.permissionGroups =
            rsp.data && rsp.data.length > 0 && rsp.data[i].groups
              ? rsp.data[i].groups
              : [];
          ap.appCode = rsp.data[i].appCode ? rsp.data[i].appCode : '';
          ap.appUuid = `app_${i}_${ap.permissionGroups.length}`;
          ap.permissionList = [];
          if (i === 0) {
            this.activeNames.push(ap.appCode);
          }
          this.getPermissionInfo(ap);
          this.appPermissionList.push(ap);
        }
      })
        .catch(err => {
          console.error(err);
        });
    },

    /**
     * @description: 更新权限渲染
     * @param {Object} ap
     * @return {*}
     */
    getPermissionInfo (ap) {
      ap.permissionGroups.forEach((item, index) => {
        // 树结构新增属性用于checkbox的使用，使用$set方便，使vue可跟踪到数据变化
        this.$set(ap.permissionList, index, {
          ...item,
          checkAll: false, // 分组勾选绑定值
          isIndeterminate: false, // 分组半候选绑定值
          perNum: item.permissions.length // 记录分组权限数量
        });
        // 生成空的勾选值分组，用于权限checkbox-group组件绑定值
        this.$set(this.checkAlias, `groupP_${ap.appUuid}_${index}`, []);
        const permissionsList = item.permissions.map(perItem => ({
          groupN: `${ap.appUuid}_${index}`,
          ...perItem
        }));
        // 树结构的分组权限转为一维数组，带上所属分组的序号信息，用于更新对应分组值、权限分组的checkbox信息
        this.aliasPermissionList = [
          ...this.aliasPermissionList,
          ...permissionsList
        ];
      });
    },

    /**
     * @description: 获取菜单权限，更新权限渲染
     * @param
     * @return {*}
     */
    getMenuPermissionInfo () {
      getMenuPermission(this.menuCode, this.elementCode)
        .then(rsp => {
          this.handleReset(rsp.data);
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 更新勾选的权限
     * @param {List} _checkList
     * @return {*}
     */
    handleReset (_checkList) {
      this.checkList = _checkList; // 更新勾选的权限，此数组与后台的菜单权限一致，不随用户操作更新，便于重置操作
      const checkAlias = JSON.parse(JSON.stringify(this.checkAlias));
      // 重置勾选权限分组
      for (const groupKey in checkAlias) {
        this.checkAlias[groupKey] = [];
      }
      // 传入值为数组循环，查找到对应的分组信息更新至勾选权限分组保存；此判断避免获取的勾选值为null
      if (_checkList) {
        _checkList.forEach(item => {
          const permissionItem = this.aliasPermissionList.find(
            PerItem => PerItem.code === item.permissionCode
          );
          if (permissionItem) {
            this.checkAlias[`groupP_${permissionItem.groupN}`].push(
              permissionItem.code
            );
          }
        });
      }
      // 更新分组权限的checkbox信息
      for (let i = 0; i < this.appPermissionList.length; i++) {
        const app = this.appPermissionList[i];
        const permissions = this.appPermissionList[i].permissionList;
        if (permissions.length > 0) {
          const permissionList = JSON.parse(JSON.stringify(permissions));
          permissionList.forEach((item, key) => {
            const checkedCount = this.checkAlias[`groupP_${app.appUuid}_${key}`].length;
            permissions[key].isIndeterminate =
              checkedCount > 0 && checkedCount < item.perNum;
            permissions[key].checkAll = checkedCount === item.perNum;
          });
        }
      }
    },
    /**
     * @description: 全选事件
     * @param {String} key 选项序号
     * @param {String} item 选项
     * @param {String} appUuid 选项所属应用的Uuid
     * @return {*}
     */
    handleCheckAllChange (key, item, appUuid) {
      // 全选事件
      let _per = [];
      if (item.checkAll) {
        _per = item.permissions.map(_item => {
          return _item.code;
        });
        this.checkAlias[`groupP_${appUuid}_${key}`] = _per;
      } else {
        this.checkAlias[`groupP_${appUuid}_${key}`] = [];
      }
      item.isIndeterminate = false;
    },
    /**
     * @description: 更新全选框状态
     * @param {String} key 选项序号
     * @param {String} item 选项
     * @param {String} appUuid 选项所属应用的Uuid
     * @return {*}
     */
    handleCheckedChange (key, item, appUuid) {
      // checkbox组勾选，更新全选框
      const checkedCount = this.checkAlias[`groupP_${appUuid}_${key}`].length;
      item.checkAll = checkedCount === item.perNum;
      item.isIndeterminate = checkedCount > 0 && checkedCount < item.perNum;
    },
    /**
     * @description: 保存
     * @param
     * @return {*}
     */
    handleSave () {
      const that = this;
      this.loading = true;
      this.fd.sysPermissionVOList = [];
      for (const groupKey in this.checkAlias) {
        if (this.checkAlias[groupKey].length > 0) {
          for (let i = 0; i < this.checkAlias[groupKey].length; i++) {
            const saveCheckList = {};
            saveCheckList.permissionCode = this.checkAlias[groupKey][i];
            this.fd.sysPermissionVOList.push(saveCheckList);
          }
        }
      }
      this.fd.menuCode = this.menuCode;
      this.fd.elementCode = this.elementCode;
      updateMenuPermission(this.fd)
        .then(() => {
          that.$alert('修改成功', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: () => { }
          });
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          that.loading = false;
        });
    }
  },
  watch: {
    /**
     * @description: 监听选择的菜单节点的页面元素编码，获取权限数据
     * @param {String} val
     * @return {*}
     */
    elementCode (val) {
      if (val) {
        this.getMenuPermissionInfo();
      } else {
        this.loading = false;
      }
    }
  },
  created () {
    this.getPermission();
  }
};
</script>

<style lang="scss">
.page-permission-list {
  .js-no-data{
    margin: 60px;
    color: #909399;
    text-align: center;
  }

  .dev-pGroup{
    background: #fff;

    & + .dev-pGroup{
      margin-top: 8px;
    }

    &__title{
      padding: 4px 6px;
      border: 1px solid #d9d9d9;
      font-weight: 600;
      color: #0c6bcd;
      background: #e6f7ff;
    }

    &__detail{
      border: 1px solid #d9d9d9;
      border-top: none;

      &.el-checkbox-group{
        display: block;
      }
    }
  }

  .dev-pDetail{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #d9d9d9;

    &.el-checkbox{
      padding-left: 12px;
      margin-right: 0 !important;
      white-space: unset;
    }

    .el-checkbox__label{
      display: flex;
      flex: 1;
      padding-left: 0;
    }

    &:last-child{
      border-bottom: none;
    }

    &__name{
      display: flex;
      align-items: center;
      flex-shrink: 0;
      width: 140px;
      padding: 2px 10px;
      word-break: break-word;
    }

    &__code{
      display: flex;
      align-items: center;
      width: 200px;
      padding: 2px 10px;
      border-right: 1px solid #d9d9d9;
      border-left: 1px solid #d9d9d9;
      word-break: break-word;
    }

    &__path{
      display: flex;
      align-items: center;
      flex: 1;
      padding: 2px 10px;
      word-break: break-word;
    }
  }

  .el-collapse{
    border: none;
  }

  .el-collapse-item__header{
    height: 32px;
    padding: 0 8px;
    line-height: 32px;
    color: #333;
    background: #ececec;
  }

  .el-collapse-item__wrap{
    padding: 8px;
    border-bottom: none;
    background: #fafafa;
  }

  .el-collapse-item__content{
    padding-bottom: 0;
  }
}
</style>
